"use client";

import { c as _c } from "react/compiler-runtime";
import MemesWaveQuickVoteTrigger from "../left-sidebar/waves/MemesWaveQuickVoteTrigger";
import { useMemesWaveFooterStats } from "@/hooks/useMemesWaveFooterStats";
interface FloatingMemesQuickVoteTriggerProps {
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
}
export default function FloatingMemesQuickVoteTrigger(t0) {
  const $ = _c(6);
  const {
    onOpenQuickVote,
    onPrefetchQuickVote
  } = t0;
  const {
    isAvailable,
    leftThisRoundCount,
    unratedCount
  } = useMemesWaveFooterStats();
  if (!isAvailable) {
    return null;
  }
  let t1;
  if ($[0] !== isAvailable || $[1] !== leftThisRoundCount || $[2] !== onOpenQuickVote || $[3] !== onPrefetchQuickVote || $[4] !== unratedCount) {
    t1 = <div className="tw-absolute tw-right-2 tw-top-2 tw-z-20 sm:tw-right-4 sm:tw-top-3"><MemesWaveQuickVoteTrigger isAvailable={isAvailable} leftThisRoundCount={leftThisRoundCount} onOpenQuickVote={onOpenQuickVote} onPrefetchQuickVote={onPrefetchQuickVote} unratedCount={unratedCount} /></div>;
    $[0] = isAvailable;
    $[1] = leftThisRoundCount;
    $[2] = onOpenQuickVote;
    $[3] = onPrefetchQuickVote;
    $[4] = unratedCount;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}